<div class="ir-area ir-mask th-mask" *ngIf="point">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="updatePoint(editForm.value)">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'points.rename' | translate }} &laquo; {{ point.name }} &raquo;</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'common.name' | translate }} *</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.name"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  type="text"
                  formControlName="name"
                  rows="3"
                  placeholder="{{ 'points.placeholders.point-name' | translate }}"
                  class="ir-form-set"
                />
              </div>
            </td>
          </tr>
        </table>
        <h2>
          <span>{{ 'common.description' | translate }}</span>
        </h2>
        <div class="ir-form-group">
          <textarea
            formControlName="description"
            rows="3"
            placeholder="{{ 'points.placeholders.description' | translate }}"
            class="ir-form-set"
            innertHtml="description"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
